"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _FlexColumn = require("../../../components/layout/flex/FlexColumn");
var _FlexRow = require("../../../components/layout/flex/FlexRow");
var _Heading = _interopRequireDefault(require("../../../components/text/Heading"));
var _Subheading = _interopRequireDefault(require("../../../components/text/Subheading"));
var _IconTooltip = _interopRequireDefault(require("../../../components/feedback/tooltip/IconTooltip"));
var _Text = _interopRequireDefault(require("../../../components/text/Text"));
var _jsxRuntime = require("react/jsx-runtime");
var InsightSection = function InsightSection(_ref) {
  var title = _ref.title,
    tooltip = _ref.tooltip,
    value = _ref.value,
    size = _ref.size,
    dataCy = _ref['data-cy'];
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FlexColumn.FlexColumn, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_FlexRow.FlexRow, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
        noWrap: true,
        size: '2',
        children: title
      }), tooltip && /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconTooltip.default, {
        iconSize: 's',
        children: tooltip
      })]
    }), size === 'l' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Heading.default, {
      noWrap: true,
      size: '4',
      "data-cy": dataCy,
      children: value
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Subheading.default, {
      noWrap: true,
      size: '2',
      "data-cy": dataCy,
      children: value
    })]
  });
};
var _default = exports.default = InsightSection;